import Vue from 'vue'
import VueI18n from 'vue-i18n'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN' // element-ui lang

Vue.use(VueI18n)

const locale = 'zh-CN' // default locale

export default new VueI18n({
  locale,
  messages: {
    // en: {

    //   ...elementEnLocale
    // },
    // zh: {

    //   ...elementZhLocale
    // },
    'zh-CN': require('./home/Zh-cn'),
    'en-US': require('./home/En-us')
  }
})



// WEBPACK FOOTER //
// ./src/assets/language/i18n.js